import React from "react";
import Box from "@mui/material/Box";

import logoSrc from './logo.svg';
import Link from "@mui/material/Link";
import {routeConfigs} from "../../../navigation/routeConfig";
import {AccountCircle} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import Logout from "@mui/icons-material/Logout";
import {useAuth} from "../../../hooks/useAuth";

interface IAuthHeaderProps {
  user?: any;
  pharmacy?: any;
}

export const AuthHeader:React.FunctionComponent<IAuthHeaderProps> = ({
  user,
  pharmacy
}) => {
  const { signOut } = useAuth();
  const accountName = !pharmacy ? `${user?.firstName} ${user?.lastName}` : pharmacy.legalName;

  return (
    <Box sx={{bgcolor: '#090808', color: '#FFFEFE', paddingX: 4, paddingY: 1, display: 'flex', alignItems: 'center', justifyContent: !user ? 'start' : 'space-between'}}>
      <Box sx={{height: '69px', cursor: 'pointer'}}>
        <Link href={routeConfigs.login.path} sx={{color: '#FFFEFE'}} variant="body2" >
          <img src={logoSrc} alt='logo' />
        </Link>
      </Box>
      {user && (
        <Box sx={{display: 'flex', alignItems: 'center'}}>
          <Box sx={{display: 'flex', alignItems: 'center', cursor: 'pointer', mr: 2, ml: 3}}>
            <AccountCircle />
            <Box sx={{ ml: 1, fontSize: 14 }}>{accountName}</Box>
          </Box>
          <IconButton
            color="inherit"
            onClick={async () => {
              await signOut();
            }}
          >
            <Logout />
          </IconButton>
        </Box>
      )}
    </Box>
  )
}

export default AuthHeader